module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Menu.js"));
	}, "Menu");
}